// extracted by mini-css-extract-plugin
module.exports = {"row":"MetricSideRow-row-1jf5uc","name":"MetricSideRow-name-1Pq8qK"};